// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from 'vue';
import App from './App';
import context from '@/context';

Vue.config.productionTip = false;

Vue.mixin({
  data() {
    return {
      context,
    };
  },
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/views/index/main.js